import {Component, Event, EventEmitter, h, Host, Prop, State} from "@stencil/core";
import {NestDatePickerHeader} from "../components/nest-date-picker-header";
import {NestDatePickerChangeView, NestDatePickerDay} from "../nest-date-picker.interfaces";
import moment, {Moment} from "moment/moment";

@Component({
  tag: 'nest-date-picker-year',
  styleUrl: '../nest-date-picker.scss',
  shadow: false
})
export class NestDatePickerYearView {
  perLine = 3;
  currentDate: Moment = moment();

  @State() rows = [];
  @State() headerLabel: string;
  @State() headerDisabled = {};

  @Prop({ mutable: true }) activeDate: Moment;
  @Prop({ mutable: true }) selectedDate: Moment;
  @Prop() minDate: Moment;
  @Prop() maxDate: Moment;

  @Event() changeView: EventEmitter<NestDatePickerChangeView>;

  private generateView(): void {
    const selectedYear: number = (this.activeDate || this.selectedDate).year();

    let startYear: number = Math.floor(selectedYear / 10) * 10;
    let endYear: number = startYear + 9;

    const minYear = this.minDate && this.minDate.year();
    const maxYear = this.maxDate && this.maxDate.year();

    this.headerDisabled = {
      prev: minYear && minYear >= startYear,
      next: maxYear && maxYear <= endYear
    }

    let year: number = startYear;

    this.rows = [];
    for (let y = 0; y < 12; y++) {
      let index = Math.floor(y / this.perLine);

      if (!this.rows[index]) this.rows[index] = [];
      this.rows[index].push({
        id: year,
        label: String(year),
        value: `${year}`,
        year: year,
        current: year === this.currentDate.year(),
        selected: this.selectedDate && year === this.selectedDate.year(),
        disabled: minYear && year < minYear || maxYear && year > maxYear,
        hide: year > endYear
      });
      year += 1;
    }

    this.headerLabel = `${startYear} - ${endYear}`;
  }

  private choose(year: NestDatePickerDay): void {
    if (year.disabled) return;
    this.activeDate = moment([year.id]);

    this.changeView.emit({ view: 'month', answer: this.activeDate });
  }

  private next(): void {
    this.activeDate.add(10, 'years')
    this.generateView()
  }

  private prev(): void {
    this.activeDate.subtract(10, 'years')
    this.generateView()
  }

  /* Lifecycles methods */
  componentWillLoad() {
    this.generateView()
  }

  render() {
    return (
      <Host>
        <NestDatePickerHeader
          actions={[{label: this.headerLabel, handler: () => this.changeView.emit({view: 'decade'})}]}
          nextHandler={this.next.bind(this)}
          prevHandler={this.prev.bind(this)}
          disabled={this.headerDisabled}
        />

        {this.rows.map(row => (
          <div class='flex flex-wrap mb-1'>
            {row.map((item) => (
              <button
                onClick={() => this.choose(item)}
                disabled={item.disabled}
                type="button"
                class={{
                  'datepicker-month__item': true,
                  'bg-gray-100': !item.selected && item.current,
                  'bg-blue-600 text-white': item.selected,
                  'disabled:text-gray-300 disabled:cursor-default': item.disabled,
                  'hidden': item.hide
                }}>
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </Host>
    )
  }
}
